import React, { useState, useEffect, useCallback } from "react";
import { Outlet, useParams } from "react-router-dom";
import { FaSearch, FaUser, FaBars } from "react-icons/fa";
import UserDetailsComponent from "./UserDetailsComponent";
import { useUser } from "../../../context/UserContext";
import config from "../../../config/config";
import axios from "axios";

const Profile = ({ user }) => {
  const [isLeftActive, setIsLeftActive] = useState(true);
  const [isRightActive, setIsRightActive] = useState(true);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const baseURL = config.API_BASE_URL;
  const { userId } = useParams();
  const { allWorkerUsers, fetchAllWorkerUsers } = useUser();

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);

      if (window.innerWidth > 768 && isRightActive) {
        setIsRightActive(true);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isRightActive]);

  useEffect(() => {
    fetchAllWorkerUsers();

    const handleVisibilityChange = async () => {
      if (document.visibilityState === "visible") {
        console.log("Tab is now visible, refetching data...");
        await fetchAllWorkerUsers();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () =>
      document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, [fetchAllWorkerUsers]);

  useEffect(() => {
    if (userId) {
      const selected = allWorkerUsers.find((worker) => worker.id === userId);
      if (selected) {
        setSelectedUser(selected);
      }
    }
  }, [userId, allWorkerUsers]);

  const toggleLeftContainer = useCallback(() => {
    setIsLeftActive((prevState) => !prevState);
  }, []);

  const showLeftPanel = () => {
    if (!isLeftActive) {
      setIsLeftActive(true);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredUsers = allWorkerUsers.filter((worker) =>
    worker.firstName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleUserClick = (user) => {
    setSelectedUser(user);
    console.log("Selected User : ", user);
    const basePath = "/account/admin-dashboard/users/worker-users";
    const newPath = `${basePath}/${user.id}`;
    window.history.pushState(null, null, newPath);
  };

  return (
    <div className="wu-area-container">
      <button onClick={toggleLeftContainer} className="toggle-left-container">
        <FaBars />
      </button>
      <div className={`wu-area-left-container ${isLeftActive ? "active" : ""}`}>
        <div className="wu-area-left-div">
          <div className="users-left-div">
            <div className="search-input-container">
              <input
                type="text"
                placeholder="Search Worker Users"
                value={searchTerm}
                onChange={handleSearchChange}
                className="users-search-input"
              />
              <FaSearch className="user-search-icon" />
            </div>
            <div className="worker-users-list">
              {filteredUsers.map((worker) => (
                <div
                  key={worker.id}
                  className={`worker-user-item ${
                    selectedUser?.id === worker.id ? "selected" : ""
                  }`}
                  onClick={() => handleUserClick(worker)}
                >
                  <FaUser className="user-list-icon" />
                  {worker.firstName} {worker.lastName}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div
        className={`wu-area-right-container ${isRightActive ? "active" : ""}`}
      >
        {selectedUser ? (
          <UserDetailsComponent
            user={selectedUser}
            toggleLeft={toggleLeftContainer}
          />
        ) : (
          <Outlet />
        )}
      </div>
    </div>
  );
};

export default Profile;
